import { render, staticRenderFns } from "./ProductHomepage.vue?vue&type=template&id=7c6f022d"
import script from "./ProductHomepage.vue?vue&type=script&lang=js"
export * from "./ProductHomepage.vue?vue&type=script&lang=js"
import style0 from "./ProductHomepage.vue?vue&type=style&index=0&id=7c6f022d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports